import { BiValueAxisStyle } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleNumberInput } from '../StyleNumberInput';
import { StyleRow } from '../StyleRow';
import { StyleTextInput } from '../StyleTextInput';

/** A value axis: shown, its title, and a fixed range if wanted. */
export const ValueAxisFields = memo(
  ({
    name,
    axis,
    onChange,
  }: {
    /** e.g. `纵轴`, `右轴`. */
    name: string;
    axis: BiValueAxisStyle;
    onChange: (patch: Partial<BiValueAxisStyle>) => void;
  }) => (
    <>
      <StyleRow label={name}>
        <BiChip
          label="显示"
          selected={axis.show}
          onPress={() => onChange({ show: true })}
        />
        <BiChip
          label="隐藏"
          selected={!axis.show}
          onPress={() => onChange({ show: false })}
        />
      </StyleRow>
      {axis.show ? (
        <>
          <StyleRow label="标题">
            <StyleTextInput
              label={`${name}标题`}
              value={axis.label ?? ''}
              placeholder="不显示"
              onChange={text => onChange({ label: text || undefined })}
            />
          </StyleRow>
          <StyleRow label="范围">
            <StyleNumberInput
              label={`${name}最小值`}
              value={axis.min}
              placeholder="自动"
              onChange={min => onChange({ min })}
            />
            <StyleNumberInput
              label={`${name}最大值`}
              value={axis.max}
              placeholder="自动"
              onChange={max => onChange({ max })}
            />
          </StyleRow>
        </>
      ) : null}
    </>
  ),
);
